import React from 'react';
import { Link } from 'react-router-dom';

const List = () => {
	return (
		<div className="container justify-content-center mt-5">
			<h3>
				Go to <Link to="/food/1">this link</Link> for germination of seeds experiment.
			</h3>
		</div>
	);
};

export default List;
